/**
 * Created by qingzhui on 17/1/20.
 */

require('../../scss/m/m-index.scss');
require('./m-common');

var $ = require('jquery');

$(function(){
    //$('.m-overview .en').hide();
});


// WEBPACK FOOTER //
// ./src/m/m-exemption.js